import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';

import {
  ButtonSecondary,
  SkeletonLoader,
  ContentDisplay,
  ListDisplay,
  Row,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { AvailableBalanceModal } from '@/modules/trade/components/AvailableBalanceModal';
import { Money } from '@/modules/common/components/MoneyV2';
import { AvailableBalanceData } from '@/modules/trade/services/unified-account/types';
import {
  getMarginAllocationV2,
  IMarginAllocationV2
} from '@/modules/trade/services/margin-allocation';
import { MarginAllocationDrawer } from '@/modules/trade/views/TradeView/components/TradeSidebar/components/MarginAllocationDrawer';
import { useRouter } from 'vue-router/composables';

interface Props {
  availableBalanceData: AvailableBalanceData;
  hasMarginAllocation?: boolean;
  loading: boolean;
  error: boolean;
}
interface Emits {
  'on-retry': () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AvailableBalance',
  props: {
    availableBalanceData: null,
    hasMarginAllocation: { type: Boolean, default: false },
    loading: { type: Boolean },
    error: { type: Boolean }
  },
  setup(__props: any, { emit }: { emit: ({
  'on-retry': () => void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { availableBalanceData: AvailableBalanceData, hasMarginAllocation: boolean, loading: boolean, error: boolean };

const router = useRouter();





const marginAllocation = ref<IMarginAllocationV2>();
const isLoadingMarginAllocation = ref(true);
const isMarginAllocationDrawerOpen = ref(false);
const isModalOpen = ref(false);

const availableToOperateValue = computed(() => {
  return props.availableBalanceData?.availableToOperateValue?.formatted || '-';
});

const fetchMarginAllocation = async () => {
  isLoadingMarginAllocation.value = true;
  try {
    const marginAllocationResponse = await getMarginAllocationV2();
    marginAllocation.value = marginAllocationResponse;
  } catch (error) {
    console.error(error);
  } finally {
    isLoadingMarginAllocation.value = false;
  }
};

const shouldShowMarginAllocation = computed(() => {
  return props.hasMarginAllocation && marginAllocation.value;
});

const hasAllocatedValue = computed(() => {
  return Number(marginAllocation.value?.balance.value) > 0;
});

const emitOnRetry = () => {
  emit('on-retry');
};

const openModal = () => {
  isModalOpen.value = true;
};

const closeModal = () => {
  isModalOpen.value = false;
};

const goToMarginAllocation = () => {
  if (hasAllocatedValue.value) {
    isMarginAllocationDrawerOpen.value = true;
  } else {
    router.push({
      name: 'marginAllocation'
    });
  }
};

onMounted(() => {
  fetchMarginAllocation();
});

return { __sfc: true,router, props, emit, marginAllocation, isLoadingMarginAllocation, isMarginAllocationDrawerOpen, isModalOpen, availableToOperateValue, fetchMarginAllocation, shouldShowMarginAllocation, hasAllocatedValue, emitOnRetry, openModal, closeModal, goToMarginAllocation, ButtonSecondary, SkeletonLoader, ContentDisplay, ListDisplay, Row, BaseText, AvailableBalanceModal, Money, MarginAllocationDrawer }
}

})